<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.student_file_tags', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-8">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.name')" for="name" />
                            <FormInput
                                id="name"
                                v-model="form.name"
                                name="name"
                                type="text"
                                max="191"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.name" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-4">
                        <div class="mt-1">
                            <FormLabel :value="$tc('messages.categories', 1)" for="student_file_tag_category_id" />
                            <FormSelect
                                id="student_file_tag_category_id"
                                v-model="form.student_file_tag_category_id"
                                :options="options.student_file_tag_categories"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.student_file_tag_category_id" class="mt-2 w-full" />
                        </div>
                    </div>

                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.description')" for="description" />
                            <FormInput
                                id="description"
                                v-model="form.description"
                                name="description"
                                type="text"
                                maxlength="180"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.description" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
        FormSelect,
    },
    layout: AdminLayout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'studentFileTag'],
    data() {
        return {
            form: this.$inertia.form({
                name: this.studentFileTag.name,
                student_file_tag_category_id: this.studentFileTag.student_file_tag_category_id,
                description: this.studentFileTag.description,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
